import { render, staticRenderFns } from "./DynamicSingleChoiceModal.vue?vue&type=template&id=f4e98888&scoped=true"
import script from "./DynamicSingleChoiceModal.vue?vue&type=script&lang=js"
export * from "./DynamicSingleChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicSingleChoiceModal.vue?vue&type=style&index=0&id=f4e98888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e98888",
  null
  
)

export default component.exports